import MemberJoinedAlertBar from './MemberJoinedAlertBar';

export default MemberJoinedAlertBar;
export type { Props } from './types';
